import { inject, Injectable } from "@angular/core";
import type { BaseFilterDefinition, FilterValue } from "@shared/filter";
import type { IBaseT1Card, TranslateObject } from "@app/views-interfaces";
import { TaxReturnStatusesService } from "@shared/tax-return-statuses-service";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

@Injectable()
export class ReturnStatusService extends SimpleFilterMulti<IBaseT1Card> {
    private readonly taxReturnStatusesService = inject(TaxReturnStatusesService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "ReturnStatus",
            label: "AllView.ReturnStatus",
        };
    }

    protected getValue(item: IBaseT1Card): FilterValue | undefined {
        return item.return?.statusId;
    }

    protected getLabel(statusId: string): string | undefined | null | TranslateObject {
        return this.taxReturnStatusesService.currentTaxReturnStatuses()?.find((item) => item.Id === statusId)?.Name;
    }

    protected getAllValues(): readonly string[] {
        return this.taxReturnStatusesService.currentTaxReturnStatuses()?.flatMap((status) => (status.Id ? [status.Id] : [])) ?? [];
    }
}
